import { render, staticRenderFns } from "./NewZealandElectronicTravelAuthority2025.vue?vue&type=template&id=0b2650f4&scoped=true"
import script from "./NewZealandElectronicTravelAuthority2025.vue?vue&type=script&lang=js"
export * from "./NewZealandElectronicTravelAuthority2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2650f4",
  null
  
)

export default component.exports